module.exports = __webpack_public_path__ + "static/iso45001-a9dc8212a1df8657234e0608c99f4946.svg";